import React from 'react';
import { images } from '../utils/assetHelpers';

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-brand-light py-8 sm:py-12 md:py-16 overflow-hidden">
      <div className="container-wide">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {/* 左侧：公司简介 */}
          <div className="space-y-4">
            <h3 className="text-xl sm:text-2xl font-bold text-yellow-400">BetterUs教练 - 上海领问科技 </h3>
            <p className="text-brand-light opacity-80 leading-relaxed">
              上海聆问者互联网信息科技有限公司旗下BetterUs是国内首家在线教练服务平台，致力于通过专业教练技术帮助个人和组织实现突破性成长。
            </p>
          </div>

          {/* 右侧：联系方式和二维码 */}
          <div className="flex flex-col md:flex-row gap-8 md:gap-4 lg:gap-8 justify-between flex-wrap">
            {/* 联系方式 */}
            <div className="md:max-w-[45%] lg:max-w-none">
              <h3 className="text-lg sm:text-xl font-semibold text-yellow-400 mb-4">联系我们</h3>
              <ul className="space-y-2">
                <li className="flex items-center space-x-2 text-brand-light">
                  <svg className="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <a href="tel:+8617338172018" className="hover:text-yellow-400 transition-colors">
                  +86 173 3817 2018
                  </a>
                </li>
                <li className="flex items-center space-x-2 text-brand-light">
                  <svg className="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a href="mailto:contact@betterus.cc" className="hover:text-yellow-400 transition-colors">
                    contact@betterus.cc
                  </a>
                </li>
                <li className="flex items-center space-x-2 text-brand-light">
                  <svg className="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <a 
                    href="https://uri.amap.com/marker?position=121.425302,31.201989&name=BetterUs" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="hover:text-yellow-400 transition-colors"
                  >
                    上海市长宁区新华路345弄4号
                  </a>
                </li>
              </ul>
            </div>

            {/* 二维码区域 */}
            <div className="flex flex-wrap gap-4 sm:gap-6 md:gap-2 lg:gap-6">
              <div className="text-center">
                <h3 className="text-lg sm:text-xl font-semibold text-yellow-400 mb-2 sm:mb-4">关注公众号</h3>
                <div className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 bg-white rounded-lg p-2">
                  <img
                    src={images.qrCodes.official}
                    alt="BetterUs公众号二维码"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-lg sm:text-xl font-semibold text-yellow-400 mb-2 sm:mb-4">添加小助手</h3>
                <div className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 bg-white rounded-lg p-2">
                  <img
                    src={images.qrCodes.wechat}
                    alt="小助手企业微信二维码"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 版权信息 */}
        <div className="pt-6 sm:pt-8 text-center">
          <p className="text-sm text-gray-400">© {new Date().getFullYear()} 上海聆问者互联网信息科技有限公司. All rights reserved.</p>
          <p className="text-sm text-gray-400 mt-2">
            <span className="mr-4">www.betterus.cc</span>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-primary"
            >
              沪ICP备20005882号-5
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
